import { useEffect, useState } from "react";
import { Plus, X } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

export default function Tags() {
  const [tags, setTags] = useState([]);
  const [name, setName] = useState("");

  const load = () => api.get("/admin/tags").then((r) => setTags(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => { if (!name.trim()) return; try { await api.post("/admin/tags", { name }); setName(""); load(); } catch (e) { toast.error(apiErr(e)); } };
  const del = async (id) => { try { await api.delete(`/admin/tags/${id}`); load(); } catch (e) { toast.error(apiErr(e)); } };

  return (
    <div className="max-w-2xl">
      <div className="mb-6"><div className="label-mono mb-1">Taxonomy</div><h1 className="font-display font-extrabold text-white text-3xl">Tags</h1></div>
      <div className="flex gap-3 mb-6">
        <input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} data-testid="tag-name" className="flex-1 bg-ink-800 border border-ink-600 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-brand text-white" placeholder="New tag name" />
        <button onClick={add} data-testid="tag-add" className="inline-flex items-center gap-1.5 bg-brand text-brand-dark font-bold text-sm px-5 py-2.5 rounded-lg hover:bg-brand-neon transition-colors"><Plus size={15} /> Add</button>
      </div>
      <div className="flex flex-wrap gap-2" data-testid="tag-list">
        {tags.map((t) => (
          <span key={t.id} className="inline-flex items-center gap-2 bg-ink-900 border border-ink-600 rounded-full px-3.5 py-1.5 text-sm text-slate-200">
            #{t.name}
            <button onClick={() => del(t.id)} className="text-slate-500 hover:text-red-400"><X size={13} /></button>
          </span>
        ))}
        {tags.length === 0 && <span className="text-slate-500 text-sm">No tags yet.</span>}
      </div>
    </div>
  );
}
